const getImageBlob = async (imgSrc) => {
    const response = await fetch(imgSrc);
    return await response.blob();
};
const downloadImage = async (imgSrc) => {
    const blob = await getImageBlob(imgSrc);
    const fileType = blob.type.split('/')[1];
    const fileName = `image.${fileType}`;
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
};
export { downloadImage, };
//# sourceMappingURL=media-container-utils.js.map